import { render, staticRenderFns } from "./sectionM5.vue?vue&type=template&id=5210cd9a&scoped=true&"
import script from "./sectionM5.vue?vue&type=script&lang=js&"
export * from "./sectionM5.vue?vue&type=script&lang=js&"
import style0 from "./sectionM5.vue?vue&type=style&index=0&id=5210cd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5210cd9a",
  null
  
)

export default component.exports